import { useState } from 'react';
import { message, Spin, Modal } from 'antd';
import axios from 'axios';
import { DownloadOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";

type FileDownloaderProps = {
    fileName: string;
    btnName: string;
    link: string;
};

const FileDownloader = ({ fileName, btnName, link }: FileDownloaderProps) => {
    const { t, i18n } = useTranslation("common");
    const currentLanguage = i18n.language;

    const [preparing, setPreparing] = useState<boolean>(false);

    const getToken = () => {
        return localStorage.getItem('accessToken');
    };

    const handleDownload = async () => {
        setPreparing(true);

        try {
            const response = await axios.get(link, {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
                responseType: 'blob', // Important for handling binary data
            });

            const blob = new Blob([response.data], { type: response.headers['content-type'] });

            // Create a link element to download the file
            const downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.download = `${fileName}.xlsx`;

            // Trigger the download
            document.body.appendChild(downloadLink);
            downloadLink.click();

            // Clean up
            document.body.removeChild(downloadLink);
        } catch (error) {
            console.error('Error downloading file:', error);
            message.error('Error downloading file');
        } finally {
            setPreparing(false);
        }
    };

    return (
        <>
            <div onClick={handleDownload}>
                <DownloadOutlined style={{
                    color: '#1677FF', fontSize: '20px', marginRight: currentLanguage == 'ar' ? '0px' : '15px',
                    marginLeft: currentLanguage == 'ar' ? '15px' : '0px'
                }} />
                {btnName}
            </div>
            <Modal visible={preparing} title={t("preparing-download")} footer={null} closable={false} centered bodyStyle={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Spin size="large" />
            </Modal>
        </>
    );
};

export default FileDownloader;
